const getDefaultCatState = () => {
  return {
    policies: [],
    exportPolicies: [],
    selectedCustomerPolicy: null,
    serverTotal: 0,
  };
};
const state = getDefaultCatState();

const getters = {
  customerPolicies: (state) => state.policies,
  selectedCustomerPolicy: (state) => state.selectedCustomerPolicy,
  serverTotal: (state) => state.serverTotal,
  exportPolicies: (state) => state.exportPolicies,
};

const actions = {
  clearCache({ commit }) {
    commit("resetState");
  },

  async fetchCustomerPolicies(
    { commit },
    {
      id,
      show_default = "true",
      results = 10,
      page = 1,
      sortBy = "name",
      sortDesc = false,
      filter = null,
    }
  ) {
    let requestURL = `/restapi/policies?user_id=${id}&show_default=${show_default}&list_locations=false&show_first_location=true&show_locations_count=true`;

    const sortDir = sortDesc[0] === false ? "asc" : "desc";
    const offset = results * page - results;
    const sortkey =
      sortBy === "os"
        ? "extra_info"
        : sortBy === "first_location"
        ? "location"
        : sortBy;

    if (results) requestURL += `&limit=${results}`;
    if (page) requestURL += `&offset=${offset}`;
    if (sortBy) requestURL += `&sortkey=${sortkey}`;
    if (sortDir) requestURL += `&sortdir=${sortDir}`;
    if (filter) requestURL += `&filter=${filter}`;

    const response = await this._vm.$http.get(requestURL);
    commit("setPolicies", response.data);
    commit("setServerTotal", response.data.total);
  },
  async exportCustomerPolicies({ commit }, { id }) {
    let requestURL = `/restapi/policies?user_id=${id}`;
    const response = await this._vm.$http.get(requestURL);
    commit("setExportPolicies", response.data);
  },
  async fetchScrollCustomerPolicies(
    { commit },
    {
      id,
      show_default = "true",
      results = 10,
      page = 1,
      sortBy = "name",
      sortDesc = false,
      filter = null,
    }
  ) {
    let requestURL = `/restapi/policies?user_id=${id}&show_default=${show_default}`;

    const sortDir = sortDesc[0] === false ? "asc" : "desc";
    const offset = results * page - results;
    const sortkey =
      sortBy === "os"
        ? "extra_info"
        : sortBy === "first_location"
        ? "location"
        : sortBy;

    if (results) requestURL += `&limit=${results}`;
    if (page) requestURL += `&offset=${offset}`;
    if (sortBy) requestURL += `&sortkey=${sortkey}`;
    if (sortDir) requestURL += `&sortdir=${sortDir}`;
    if (filter) requestURL += `&filter=${filter}`;

    const response = await this._vm.$http.get(requestURL);
    commit("addPolicies", response.data);
  },

  async fetchCustomerPolicy(
    { commit },
    { id, policyId, listLocations = false }
  ) {
    const response = await this._vm.$http.get(
      `/restapi/policies/${policyId}?user_id=${id}&list_locations=${listLocations}&show_first_location=true&show_locations_count=true`
    );

    if (listLocations) {
      response.data.locations = response.data.locations.map((location) => {
        if (location.type === "staticip") {
          return { ...location, ip: location.addresses[0].ip };
        }
        return location;
      });
    } else {
      response.data.locations = [response.data.first_location];
    }

    commit("setSelectedPolicy", response.data);
    commit("updatePolicies", response.data);
  },

  async createCustomerPolicy({ commit }, { id, body }) {
    const response = await this._vm.$http.post(
      `/restapi/policies?user_id=${id}`,
      body
    );

    commit("addPolicy", response.data);
    return response.data;
  },

  async updateCustomerPolicy({ commit }, { id, policyId, policy }) {
    const response = await this._vm.$http.put(
      `/restapi/policies/${policyId}?user_id=${id}`,
      policy
    );
    commit("setSelectedPolicy", response.data);
    commit("updatePolicies", response.data);
  },

  async patchCustomerPolicyInheritance(
    // eslint-disable-next-line no-unused-vars
    { commit },
    { id, policyId, inheritance }
  ) {
    const response = await this._vm.$http.patch(
      `restapi/users/${id}/policies/${policyId}`,
      inheritance
    );
    return response.data;
  },

  async deleteCustomerPolicies({ commit }, { userId, policies }) {
    const req = {};

    for (const policy of policies) {
      req[`${policy.id}`] = {
        method: "delete",
        path: `policies/${policy.id}?user_id=${userId}`,
      };
    }

    const res = await this._vm.$http.post("/restapi/batch", req);
    const ids = Object.keys(res.data).map((item) => +item);
    commit("deletePolicy", ids);
  },
};

const mutations = {
  resetState(state) {
    Object.assign(state, getDefaultCatState());
  },
  setPolicies: (state, data) => (state.policies = data.data),
  setExportPolicies: (state, data) => (state.exportPolicies = data.data),
  addPolicies(state, data) {
    state.policies.push(...data.data);
    const uniqueIds = new Set();
    const unique = state.policies.filter((element) => {
      const isDuplicate = uniqueIds.has(element.id);

      uniqueIds.add(element.id);

      if (!isDuplicate) {
        return true;
      }

      return false;
    });
    state.policies = unique;
  },
  setServerTotal: (state, data) => (state.serverTotal = data),
  addPolicy: (state, data) => state.policies.push(data),
  setSelectedPolicy: (state, data) => (state.selectedCustomerPolicy = data),
  updatePolicies: (state, data) =>
    (state.policies = state.policies.map((policy) => {
      if (policy.id === parseInt(data.id)) return { ...policy, ...data };
      return policy;
    })),
  deletePolicy(state, policies) {
    for (const policy of policies) {
      state.policies = state.policies.filter(
        (statePolicy) => statePolicy.id !== policy
      );
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
